// extracted by mini-css-extract-plugin
export default {"dailyCashRewards":"dailyCashRewards_dailyCashRewards__g1s1r"};